<script>
export default {
    type: "mscombidy2d",
                width: "100%",
                height: "350",
                dataFormat: "json",
                dataSource: {
                    chart: {
                        // caption: "Split of visitors by Channels",
                        // placevaluesinside: "1",
                        // showvalues: "1",
                        // plottooltext:
                        //     "<b>$dataValue</b> $seriesName Pada $label",
                        theme: "fusion",
                        caption: "JUMLAH HASIL TANAH",
                        // subCaption: "For last year",
                        // xAxisname: "Month",
                        pYAxisName: "Jumlah Kutipan",
                        sYAxisName: "Peratus %",
                        // numberPrefix: "$",
                        sNumberSuffix: "%",
                        // sYAxisMaxValue: "300",
                    },
                    categories: [
                        {
                            category: [
                                {
                                    label: "April 2022",
                                },
                                {
                                    label: "April 2021",
                                },
                                {
                                    label: "April 2020",
                                },
                            ],
                        },
                    ],
                    dataset: [
                        {
                            seriesname: "Anggaran",
                            color: "#F76E11",
                            data: [
                                { value: "490013750.00 " },
                                { value: "501694290.00 " },
                                { value: "499000000.00 " },
                            ],
                        },
                        {
                            seriesname: "Kutipan",
                            color: "#FF9F45",
                            data: [
                                { value: "56390010.97 " },
                                { value: "72830278.49" },
                                { value: "57347615.15 " },
                            ],
                        },
                        {
                            seriesName: "Peratus %",
                            parentYAxis: "S",
                            renderAs: "line",
                            showValues: "0",
                            color: "#000000",
                            data: [
                                {
                                    value: "11.51",
                                },
                                {
                                    value: "14.52",
                                },
                                {
                                    value: "11.49",
                                },
                            ],
                        },
                    ],
                },
};
</script>
